import { render } from "./AuraProcessingCosts.vue?vue&type=template&id=5dd9f149&ts=true"
import script from "./AuraProcessingCosts.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuraProcessingCosts.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/pages/aura/AuraProcessingCosts.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dd9f149"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dd9f149', __exports__)) {
    api.reload('5dd9f149', __exports__)
  }
  
  module.hot.accept("./AuraProcessingCosts.vue?vue&type=template&id=5dd9f149&ts=true", () => {
    api.rerender('5dd9f149', render)
  })

}


export default __exports__